import GATSBY_COMPILED_MDX from "/app/frontend/content/pages/pollens/chene.md";
import {graphql} from "gatsby";
import React from "react";
import Section from "components/base/Section";
import Web from "components/layout/Web";
function Page(props) {
  return React.createElement(Web, {
    title: props.data.mdx.frontmatter.title
  }, React.createElement(Section, {
    className: "px-6 pt-10 xl:pt-20",
    medium: true
  }, React.createElement("h1", {
    dangerouslySetInnerHTML: {
      __html: props.data.mdx.frontmatter.title
    }
  }), props.children));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Page, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query Page($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
      }
    }
  }
`;
